module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/Compass-e27bf158da9dcee51deaaa5daa5124e2.jpg";